import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.set-prototype-of";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext, useMemo } from 'react';
import flattenDeep from 'lodash/flattenDeep';
import each from 'lodash/each';
import set from 'lodash/set';
import uniq from 'lodash/uniq';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';
import isNull from 'lodash/isNull';
import merge from 'lodash/merge';
import pickWildcards from './lib/pick-wildcards';
import migrate, { validate, isValid } from './migrations';
import { schemaPropType } from './lib/validate-schema';
import { map } from './lib/tree-utils';
import StructuredContentProvider, { ClientContext } from './structured-content-provider'; // PrimitiveContext is used for scenarios where a node of a given type renders
// another <StructuredContent /> component nested inside of it
//
// In that scenario, the `Primitive` prop supplied to the <StructuredContent />
// rendered at the top of the content tree should be re-supplied to any
// nested <StructuredContent /> rendered anywhere down in the content tree

var PrimitiveContext = React.createContext(null); // NodeContext is used to wrap each rendered Component
// with the data for the current node being rendered

export var NodeContext = React.createContext();
export var DocumentContext = React.createContext();

var StructuredContent = function StructuredContent(_ref) {
  var shouldMigrate = _ref.migrate,
      children = _ref.children,
      schemaProp = _ref.schema,
      PrimitiveProp = _ref.Primitive,
      props = _objectWithoutProperties(_ref, ["migrate", "children", "schema", "Primitive"]);

  var _useContext = useContext(ClientContext),
      schemaFromContext = _useContext.schema,
      componentsStore = _useContext.componentsStore;

  var schema = schemaProp || schemaFromContext; // migrate content if props.migrate is true

  var content = useMemo(function () {
    if (!shouldMigrate) {
      return children;
    }

    if (isValid(children, schema)) {
      return children;
    }

    var migrated = migrate(children, schema);
    return migrated;
  }, [children, schema, shouldMigrate]); // validate the content can be rendered
  // throws an error if validation fails

  useMemo(function () {
    return validate(content, schema);
  }, [content, schema]); // preload all components in content tree

  var components = useMemo(function () {
    // get Component reference for each unique type
    var types = uniq(map(content, schema, function (_ref2) {
      var type = _ref2.type;
      return type;
    }));
    var treeComponents = types.reduce(function (memo, type) {
      var Component = componentsStore.load(type);
      return _objectSpread({}, memo, _defineProperty({}, type, Component));
    }, {});
    return treeComponents;
  }, [content, schema, componentsStore]); // determine the Primitive component used to render raw strings and numbers in the content

  var PrimitiveFromContext = useContext(PrimitiveContext); // PrimitiveFromContext exists when <StructuredContent /> is being rendered somewhere
  // nested in another <StructuredContent /> Component
  //
  // PrimitiveFromContext does NOT exist when this is the
  // top-level <StructuredContent /> component

  var Primitive = PrimitiveFromContext || PrimitiveProp; // Put the Primitive in context, then render the content

  return React.createElement(PrimitiveContext.Provider, {
    value: Primitive
  }, React.createElement(DocumentContext.Provider, {
    value: content
  }, React.createElement(StructuredContentImpl, _extends({}, props, {
    schema: schema,
    Primitive: Primitive,
    components: components
  }), content)));
};

StructuredContent.defaultProps = {
  renderNode: function renderNode() {},
  Primitive: function Primitive(_ref3) {
    var children = _ref3.children;
    return children;
  },
  migrate: true
};

if (process.env.NODE_ENV !== 'production') {
  var PropTypes = require('prop-types'); // eslint-disable-line global-require


  var structuredContentNodePropType = PropTypes.shape({
    type: PropTypes.string.isRequired,
    version: PropTypes.string.isRequired,
    props: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types

  });
  var structuredContentPropType = PropTypes.oneOfType([structuredContentNodePropType, PropTypes.arrayOf(PropTypes.oneOfType([structuredContentNodePropType, PropTypes.string, PropTypes.number, // recursive array prop-type checker
  PropTypes.arrayOf(function () {
    return function () {
      return structuredContentPropType;
    };
  })]).isRequired)]);
  StructuredContent.propTypes = {
    /**
     * (Default supplied by `SchemaContext.Consumer`)
     */
    schema: schemaPropType,
    // eslint-disable-line react/require-default-props

    /**
     * JSON document to render
     */
    children: structuredContentPropType.isRequired,

    /**
     * Component to render primitive strings and numbers
     * Defaults to `Type` from src/components/Type
     */
    Primitive: PropTypes.elementType,

    /**
     * Optional method to to modify what is rendered for each type
     */
    renderNode: PropTypes.func,

    /**
     * Automatically migrate documents to schema before rendering
     */
    migrate: PropTypes.bool
  };
}

StructuredContent.Provider = StructuredContentProvider;
export default StructuredContent;

var StructuredContentImpl =
/*#__PURE__*/
function (_React$Component) {
  _inherits(StructuredContentImpl, _React$Component);

  function StructuredContentImpl() {
    _classCallCheck(this, StructuredContentImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(StructuredContentImpl).apply(this, arguments));
  }

  _createClass(StructuredContentImpl, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props = this.props,
          schema = _this$props.schema,
          children = _this$props.children,
          renderNode = _this$props.renderNode,
          Primitive = _this$props.Primitive,
          components = _this$props.components; // eslint-disable-line prettier/prettier

      if (schema !== nextProps.schema) return true;
      if (children !== nextProps.children) return true;
      if (Primitive !== nextProps.Primitive) return true;
      if (renderNode !== nextProps.renderNode) return true;
      if (components !== nextProps.components) return true;
      return false;
    } // this is defined and noop-ed
    // to use in test assertions

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {} // it's turtles all the way down

  }, {
    key: "createRecursiveNode",
    value: function createRecursiveNode(node, _ref4) {
      var _this = this;

      var renderNode = _ref4.renderNode,
          path = _ref4.path;
      var components = this.props.components;
      var _this$props2 = this.props,
          schema = _this$props2.schema,
          Primitive = _this$props2.Primitive; // render leafs

      if (isNull(node)) return null;
      if (isString(node)) return React.createElement(Primitive, {
        key: path
      }, node); // eslint-disable-line prettier/prettier

      if (isNumber(node)) return React.createElement(Primitive, {
        key: path
      }, node); // eslint-disable-line prettier/prettier
      // render lists

      if (isArray(node)) {
        return node.map(function (n, i) {
          // keep track of path in list
          var arrayPath = path ? "".concat(path, ".").concat(i) : "".concat(i);
          return _this.createRecursiveNode(n, {
            renderNode: renderNode,
            path: arrayPath
          });
        });
      } // render structured-content json objects


      var type = node.type,
          props = node.props;
      var nodeProps = schema[type].nodeProps;
      var propsToRender = merge({
        key: path
      }, props); // start to build key for child nodes

      var propsPath = path ? "".concat(path, ".props") : 'props'; // recursively render any props that are `PropTypes.node` as StructuredContentNode
      // and merge those recursively rendered structured props to final props to be rendered

      each(pickWildcards(props, nodeProps), function (propValue, propPath) {
        var renderNodeProp = function renderNodeProp(childNode, i) {
          // keep track of path in node tree
          var childPath = "".concat(propsPath, ".").concat(propPath, ".").concat(i); // render child nodes

          return _this.createRecursiveNode(childNode, {
            renderNode: renderNode,
            path: childPath
          }); // eslint-disable-line prettier/prettier
        }; // recursively render child structured-content nodes


        set(propsToRender, propPath, flattenDeep([propValue]).map(renderNodeProp)); // eslint-disable-line prettier/prettier
      }); // render this node in its component

      var Component = components[type];
      var renderedNode = renderNode(_objectSpread({}, node, {
        props: propsToRender
      }), Component) || React.createElement(Component, propsToRender);
      return React.createElement(NodeContext.Provider, {
        value: node,
        key: path
      }, renderedNode);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          renderNode = _this$props3.renderNode,
          children = _this$props3.children;
      return this.createRecursiveNode(children, {
        renderNode: renderNode
      });
    }
  }]);

  return StructuredContentImpl;
}(React.Component);

_defineProperty(StructuredContentImpl, "defaultProps", _objectSpread({}, StructuredContent.defaultProps));

if (process.env.NODE_ENV !== 'production') {
  var _PropTypes = require('prop-types'); // eslint-disable-line global-require


  StructuredContentImpl.propTypes = _objectSpread({}, StructuredContent.propTypes, {
    /**
     * (internal) map of { [TYPE]: ComponentForType } of components loaded into componentsStore
     */
    components: _PropTypes.objectOf(_PropTypes.elementType).isRequired
  });
}

var __forTests = {
  // eslint-disable-line no-underscore-dangle,prettier/prettier
  StructuredContentImpl: StructuredContentImpl
};
export { __forTests };